import { apiSlice } from '../../api/apiSlice';

export const qSetApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getResourceSets: builder.mutation({
      query: () => ({
        url: 'QSet',
        method: 'GET',
        credentials: 'include'
      })
    }),
    createResourceSet: builder.mutation({
      query: (options) => ({
        url: 'QSet',
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: {...options}
      })
    }),
    moveQSetDocument: builder.mutation({
      query: (option) => ({
        url: `QSet?setId=${option.setId}&sourceIndex=${option.sourceIndex}&destinationIndex=${option.destinationIndex}`,
        method: 'PUT',
        credentials: 'include'
      })
    }),
    getQuestionSets: builder.mutation({
      query: (options) => ({
        url: `QSet/${options.skip}/${options.take}`,
        method: 'POST',
        credentials: 'include',
        body: options
      })
    }),
    deleteQuestionSets: builder.mutation({
      query: (options) => ({
        url: `QSet?isRestore=${options.isRestore}`,
        method: 'DELETE',
        credentials: 'include',
        body: options.ids
      })
    }),
    renameQuestionSet: builder.mutation({
      query: (options) => ({
        url: `QSet/${options.id}/Rename?description=${options.description}`,
        method: 'PUT',
        credentials: 'include'
      })
    }),
    addLabelsToQuestionSets: builder.mutation({
      query: (options) => ({
        url: `QSet/${options.id}/AddLabels`,
        method: 'PUT',
        credentials: 'include',
        body: options.labels
      })
    }),
    getQuestionSetProperties: builder.mutation({
      query: (options) => ({
        url: `QSet/${options.id}/Properties`,
        method: 'GET',
        credentials: 'include'
      })
    }),
    exportQuestionSetsToXml: builder.mutation({
      query: (options) => ({
        url: 'QSet/ExportToXml',
        method: 'POST',
        credentials: 'include',
        body: options.ids
      })
    }),
    importFromXml: builder.mutation({
      query: (options) => ({
        url: 'QSet/ImportFromXml',
        method: 'POST',
        credentials: 'include',
        body: options
      })
    }),
    transferQuestionSetsToTeacher: builder.mutation({
      query: (options) => ({
        url: `QSet/TransferToTeacher/?teacherId=${options.teacherId}`,
        method: 'PUT',
        credentials: 'include',
        body: options.ids
      })
    }),
    transferQuestionSetsToAdmin: builder.mutation({
      query: (options) => ({
        url: `QSet/TransferToAdmin/?adminId=${options.adminId}`,
        method: 'PUT',
        credentials: 'include',
        body: options.ids
      })
    }),
    getTagNodes: builder.mutation({
      query: (option) => ({
        url: `Tag/Nodes?node=${option.node}`,
        method: 'GET',
        credentials: 'include'
      })
    }),
    getAttributeNodes: builder.mutation({
      query: (option) => ({
        url: `Attribute/Nodes?node=${option.node}`,
        method: 'GET',
        credentials: 'include'
      })
    }),
    getStandardNodes: builder.mutation({
      query: (option) => ({
        url: `Standard/Nodes?node=${option.node}`,
        method: 'GET',
        credentials: 'include'
      })
    }),
    getTopicNodes: builder.mutation({
      query: (option) => ({
        url: `Topic/Nodes?node=${option.node}`,
        method: 'GET',
        credentials: 'include'
      })
    }),
    addCastleQuestionsToQSet: builder.mutation({
      query: (option) => ({
        url: `QSet/${option.id}/CastleQuestions`,
        method: 'POST',
        credentials: 'include',
        body: option.selectedQuestions
      })
    }),
    addSetsToQSet: builder.mutation({
      query: (options) => ({
        url: `QSet/${options.id}/ReadingSetQuestions`,
        method: 'POST',
        credentials: 'include',
        body: options.setIds
      })
    }),
    addRandomMathSkillToQSet: builder.mutation({
      query: (options) => (
        {
          url: `QSet/${options.id}/RandomMathSkillQuestions`,
          method: 'POST',
          credentials: 'include',
          body: options.params
        }
      )
    }),
    addMathSkillQuestionsToQSet: builder.mutation({
      query: (options) => (
        {
          url: `QSet/${options.id}/MathSkillQuestions?courseId=${options.courseId}`,
          method: 'POST',
          credentials: 'include',
          body: options.questionIds
        }
      )
    }),
    GetQSetDetails: builder.mutation({
      query: (option) => ({
        url: `QSet/${option.setId}/details`,
        method: 'GET',
        credentials: 'include'
      })
    }),
    GetQuestionPreview: builder.mutation({
      query: (option) => ({
        url: `QSet/${option.setId}/Questions/${option.questionNo}?languageId=${option.languageId}`,
        method: 'GET',
        credentials: 'include'
      })
    }),
    DeleteQuestion: builder.mutation({
      query: (option) => ({
        url: `QSet/${option.setId}/Question/${option.questionId}`,
        method: 'DELETE',
        credentials: 'include'
      })
    }),
    GetQuestion: builder.mutation({
      query: (option) => ({
        url: `QSet/question/${option.questionId}?courseId=${option.courseId}`,
        method: 'GET',
        credentials: 'include'
      })
    }),
    saveCRQuestion: builder.mutation({
      query: (option) => ({
        url: `QSet/${option.id}/CRQuestion`,
        method: 'POST',
        credentials: 'include',
        body:{...option.params}
      })
    }),
    moveQsetQuestion: builder.mutation({
      query: (option) => ({
        url: `QSet/${option.setId}/MoveQsetQuestion`,
        method: 'PUT',
        credentials: 'include',
        body: option.questionIds
      })
    }),
    duplicateCLOQuestionForEdit: builder.mutation({
      query: (option) => ({
        url: `QSet/${option.setId}/Question/${option.questionId}/DuplicateCLOQuestionForEdit?courseId=${option.courseId}`,
        method: 'POST',
        credentials: 'include',
        body: option.questionIds
      })
    }),
    renameQuestionDocument: builder.mutation({
      query: (option) => ({
        url: `QuestionDocument/Question/${option.questionId}/Document/${option.documentId}/rename?label=${option.documentName}`,
        method: 'PUT',
        credentials: 'include',
      })
    }),
    saveMcFillInQuestion: builder.mutation({
      query: (option) => ({
        url: `QSet/${option.id}/McFillInQuestion`,
        method: 'POST',
        credentials: 'include',
        body:{...option.params}
      })
    }),
    updateMcFillInQuestion: builder.mutation({
      query: (option) => ({
        url: `TQuestion/${option.questionId}/Question`,
        method: 'PUT',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: option.question
      })
    }),
    updateHint: builder.mutation({
      query: (option) => ({
        url: `TQuestion/${option.questionId}/Hint`,
        method: 'PUT',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: option.hint
      })
    }),
    updateReason: builder.mutation({
      query: (option) => ({
        url: `TQuestion/${option.questionId}/Reason`,
        method: 'PUT',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: option.reason
      })
    }),
    updateAnswerOptions: builder.mutation({
      query: (option) => ({
        url: `TQuestion/${option.questionId}/AnswerOptions`,
        method: 'PUT',
        credentials: 'include',
        body: option.params
      })
    }),
    getCrAnswerTools: builder.mutation({
      query: () => ({
        url: 'QSet/CRAnswerTools',
        method: 'GET',
        credentials: 'include'
      })
    }),
    updateProperties: builder.mutation({
      query: (option) => ({
        url: `TQuestion/${option.questionId}/Properties`,
        method: 'PUT',
        credentials: 'include',
        body:{...option.params}
      })
    }),
    attachResources: builder.mutation({
      query: (option) => ({
        url: `QuestionDocument/Add?questionId=${option.questionId}&qsetId=${option.setId}&courseId=${option.courseId}`,
        method: 'POST',
        credentials: 'include',
        body:option.documents
      })
    }),
    updateResourceDisplay: builder.mutation({
      query: (option) => ({
        url: `QuestionDocument/Question/${option.questionId}/Document/${option.documentId}/display?displayWithQuestion=${option.displayWithQuestion}`,
        method: 'PUT',
        credentials: 'include'
      })
    }),
    deleteQuestionDocument: builder.mutation({
      query: (option) => ({
        url: `QuestionDocument/Question/${option.questionId}/Document/${option.documentId}`,
        method: 'DELETE',
        credentials: 'include'
      })
    }),
    moveQuestionDocument: builder.mutation({
      query: (option) => ({
        url: `QuestionDocument/Reposition?questionId=${option.questionId}`,
        method: 'PUT',
        credentials: 'include',
        body: option.documents
      })
    }),
    updateCRQuestion: builder.mutation({
      query: (option) => ({
        url: `TCRQuestion/${option.questionId}/Question`,
        method: 'PUT',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: option.question
      })
    }),
    updateCRAnswer: builder.mutation({
      query: (option) => ({
        url: `TCRQuestion/${option.questionId}/Answer`,
        method: 'PUT',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: option.answer
      })
    }),
    updateCROptions: builder.mutation({
      query: (option) => ({
        url: `TCRQuestion/${option.questionId}/Options`,
        method: 'PUT',
        credentials: 'include',
        body: option.params
      })
    }),
    updateCRProperties: builder.mutation({
      query: (option) => ({
        url: `TCRQuestion/${option.questionId}/Properties`,
        method: 'PUT',
        credentials: 'include',
        body:{...option.params}
      })
    }),
    getQsetDropdownDetails: builder.mutation({
      query: (options) => ({
        url: `QSet/${options.skip}/${options.take}/Dropdown?searchString=${options.searchString}`,
        method: 'GET',
        credentials: 'include'
      })
    }),
    getVocabulary: builder.mutation({
      query: (options) => ({
        url: `QSet/${options.id}/Vocabulary`,
        method: 'GET',
        credentials: 'include'
      })
    }),
    getCanShowDeleted: builder.mutation({
      query: () => ({
        url: 'QSet/CanShowDeleted',
        method: 'GET',
        credentials: 'include'
      }),
      extraOptions: { showGlobalError: true }
    }),
    deleteFlashCard:  builder.mutation({
      query: (options) => ({
        url: `FlashCard/${options.flashcardId}/Delete?setId=${options.setId}`,
        method: 'DELETE',
        credentials: 'include'
      }),
      extraOptions: { showGlobalError: true }
    }),
    saveFlashcard:  builder.mutation({
      query: (options) => ({
        url: `FlashCard?setId=${options.setId}`,
        method: 'POST',
        credentials: 'include',
        body: {...options.params}
      }),
      extraOptions: { showGlobalError: true }
    }),
    getFlashcard:  builder.mutation({
      query: (options) => ({
        url: `FlashCard/${options.id}`,
        method: 'GET',
        credentials: 'include'
      }),
      extraOptions: { showGlobalError: true }
    }),
    updateFlashcard:  builder.mutation({
      query: (options) => ({
        url: `FlashCard/${options.id}`,
        method: 'PUT',
        credentials: 'include',
        body: {...options.params}
      }),
      extraOptions: { showGlobalError: true }
    }),
    createFlashcardWithSet: builder.mutation({
      query: (options) => ({
        url: 'Flashcard/FlashcardWithSet',
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: {...options}
      }),
      extraOptions: { showGlobalError: true }
    }),
    getQuestions: builder.mutation({
      query: (options) => ({
        url: `QSet/${options.id}/Questions?languageId=${options.languageId}`,
        method: 'GET'
      }),
      extraOptions: { showGlobalError: true }
    }),
    createFlashcardSet: builder.mutation({
      query: (options) => ({
        url: `Flashcard/Assignment/${options.assignmentId}/FlashcardSet`,
        method: 'POST'
      }),
      extraOptions: { showGlobalError: true }
    }),
  })
});

export const {
  useGetResourceSetsMutation,
  useCreateResourceSetMutation,
  useMoveQSetDocumentMutation,
  useGetQuestionSetsMutation,
  useDeleteQuestionSetsMutation,
  useRenameQuestionSetMutation,
  useAddLabelsToQuestionSetsMutation,
  useGetQuestionSetPropertiesMutation,
  useExportQuestionSetsToXmlMutation,
  useImportFromXmlMutation,
  useTransferQuestionSetsToTeacherMutation,
  useTransferQuestionSetsToAdminMutation,
  useGetTagNodesMutation,
  useGetAttributeNodesMutation,
  useGetStandardNodesMutation,
  useGetTopicNodesMutation,
  useSaveMcFillInQuestionMutation,
  useAddCastleQuestionsToQSetMutation,
  useAddSetsToQSetMutation,
  useAddRandomMathSkillToQSetMutation,
  useAddMathSkillQuestionsToQSetMutation,
  useGetQSetDetailsMutation,
  useGetQuestionPreviewMutation,
  useDeleteQuestionMutation,
  useGetQuestionMutation,
  useSaveCRQuestionMutation,
  useMoveQsetQuestionMutation,
  useDuplicateCLOQuestionForEditMutation,
  useRenameQuestionDocumentMutation,
  useGetCrAnswerToolsMutation,
  useUpdateMcFillInQuestionMutation,
  useUpdateHintMutation,
  useUpdateReasonMutation,
  useUpdateAnswerOptionsMutation,
  useUpdatePropertiesMutation,
  useAttachResourcesMutation,
  useUpdateResourceDisplayMutation,
  useDeleteQuestionDocumentMutation,
  useMoveQuestionDocumentMutation,
  useUpdateCRQuestionMutation,
  useUpdateCRAnswerMutation,
  useUpdateCROptionsMutation,
  useUpdateCRPropertiesMutation,
  useGetQsetDropdownDetailsMutation,
  useGetVocabularyMutation,
  useGetCanShowDeletedMutation,
  useDeleteFlashCardMutation,
  useSaveFlashcardMutation,
  useGetFlashcardMutation,
  useUpdateFlashcardMutation,
  useCreateFlashcardWithSetMutation,
  useGetQuestionsMutation,
  useCreateFlashcardSetMutation
} = qSetApi;